<template>
    <div class="news" v-if="newsStatus">
        <h2 style="display: block;">Новости</h2>
        <div id="news-wrapper">
            <div class="column uk-width-1-2" @click="() => { showSingleNewsModal(e.text, e.img, e.date) }" v-for="(e,i) in newsList" :key="i" :style="{                boxShadow: e.img ? '#aaa 0px 5px 15px' : 0,                cursor: e.text ? 'pointer' : 'default',                backgroundColor: e.img ? '#fff' : 'transparent'        }">
                <div class="wrapper" :style="{padding: e.img ? '0' : '15px !important'}">
                    <div class="single-news-img" :style="{'background-image': (e.img ? `url(${e.img})` : 'unset'), height: (e.img ? '200px' : 0)}"></div>
                    <p class="date" :style="{padding: (e.img ? '5px 0 0 15px' : '0')}">{{date_format(e.date, true)}}</p>
                    <div :style="{padding: (e.img ? '0 15px 10px' : '0')}">
                        <p class="single-news-text" v-html="e.title"></p>
                        <p class="show-single-news" v-if="e.text">Подробнее</p>
                    </div>
                </div>
            </div>
        </div>
        <div id="news-show-more" v-if="newsList.length < newsTotal" @click="getNews()">Показать ещё</div>
        <modal v-if="showModal" :close="() => {closeModalClickHandle()}" :customInnerWidth="'875px'" :customInnerHeight="'auto'">
            <div class="news__modal-header" slot="modalHeader">
                <div class="news__modal-date">{{date_format(modalDate, true)}}</div>
            </div>
            <div class="news__modal-body" slot="modalBody">
                <div
                    class="news__modal-screenshot"
                    @click="clickBigScreenShot"
                    v-if="modalImg"
                    :style="{
                        background: `url(${modalImg}) no-repeat scroll top center`,
                        backgroundSize: 'cover',
                        height: modalImg ? '400px' : 'auto'
                    }">
                </div>
                <p class="news__modal-text" v-html="modalText"></p>
            </div>
        </modal>
        <img class="imageView" :src="modalImg" @click="() => { this.showFullScreenImg = false }" v-if="showFullScreenImg" />
    </div>
</template>

<script>
import modal from './../ui/modal.vue'
import axios from 'axios'

export default {
    components: { modal },
    data() {
        return {
            modalText: "",
            modalDate: "",
            modalImg: '',
            newsLimit: 4,
            page: 1,
            showModal: false,
            showFullScreenImg: false,
            newsList: [],
            newsTotal: null,
            newsStatus: false
        }
    },
    methods: {
        clickBigScreenShot() {
            this.showFullScreenImg = true
        },
        openImg(imgPath) {
            window.open(window.location.origin + imgPath)
        },
        showSingleNewsModal(text, imgPath, date) {
            this.showModal = true
            this.modalText = text
            this.modalDate = date
            this.modalImg = imgPath
        },
        closeModalClickHandle() {
            this.showModal = false
            this.showFullScreenImg = false
        },
        getNews() {
            axios({
                method: "GET",
                // @ts-ignore
                url: `https://licweb.ru/le_news/getNews.php?limit=${this.newsLimit}&offset=${(this.page - 1) * this.newsLimit}`,
                headers: this.$store.state.axios.headers
            }).then(result => {
                if (result.data.total > 0) {
                    this.newsStatus = true
                    this.newsTotal = result.data.total
                    result.data.news.forEach(newsItem => this.newsList.push(newsItem));
                }
            }).catch(err => console.error(err));
            this.page++;
            $(document.getElementById("news-wrapper")).trigger("resize")
        }
    },
    mounted() { this.getNews() },
    watch: {
        newsStatus() {
            setTimeout(() => {
                UIkit.grid(document.getElementById("news-wrapper"), { gutter:5 })
                $(document.getElementById("news-wrapper")).trigger("resize")
            }, 0);
        }
    }
}
</script>

<style lang="scss">
.news {
    text-align: center;

    h2 { text-align: left; }

    .single-news-img {
        background: no-repeat top center;
        background-size: cover;
        width: 100%;
        border-top-right-radius: 15px;
        border-top-left-radius: 15px;
    }

    .column {
        text-align: left;
        margin: 10px 15px;
        display: inline-block;
        vertical-align: top;
        width: calc(50% - 33px);
        border-radius: 15px;
        padding: 0px !important;

        p.date {
            color:  #4d4e4f;
            margin-top: 10px;
            margin-bottom: 10px;
            font-size: 14px;
        }
        .single-news-text {
            display: inline-block;
            margin: 0;
        }
        .show-single-news {
            display: inline-block;
            margin: 8px 0 0;
            font-size: 14px;
            font-weight: bold !important;
            color: #88a3d6;
            cursor: pointer;
        }
    }

    #news-show-more {
        width: 170px;
        background-color: #fcc90b;
        text-align: center;
        margin: 30px auto;
        height: 40px;
        line-height: 42px;
        color: #333;
        border-radius: 20px;
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
    }

    .custom-modal {
        .news__modal-header .news__modal-date {
            font-size: 22px;
        }
        .news__modal-body {
            .news__modal-screenshot {
                cursor: zoom-in;
                box-shadow: #999 0px 5px 10px -5px;
            }
            .news__modal-text {
                padding: 25px 20px 10px;
                i { font-style: italic; }
                ul li { list-style: disc; }
            }
        }
    }

    .imageView {
        cursor: zoom-out;
        width: 80%;
        left: 10%;
        top: 50px;
        position: fixed;
        z-index: 123456;
        box-shadow: 0 0 0 100000px rgba(0,0,0,.75)
    }

    & >>> i:not(.lnr) {
        font-style: italic;
    }
}
</style>
